import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guard/auth.guard";
import { MailmanagerResolve } from "./resolve/mailmanager.resolve";

const routes: Routes = [
  { path: "index.html", redirectTo: "/dashboard" },
  { path: "index", redirectTo: "/dashboard" },
  {
    path: "uebersicht",
    loadChildren: () => import("./uebersicht/uebersicht.module").then((m) => m.UebersichtPageModule),
    canActivate: [AuthGuard],
    data: { title: "Kundentermine" },
  },
  {
    path: "dashboard",
    loadChildren: () => import("./dashboard/dashboard.module").then((m) => m.DashboardPageModule),
    canActivate: [AuthGuard],
    data: { title: "Dashboard" },
  },
  {
    path: "",
    loadChildren: () => import("./tabs/tabs.module").then((m) => m.TabsPageModule),
    pathMatch: "prefix",
  },
  {
    path: "user",
    loadChildren: () => import("./user/user.module").then((m) => m.UserPageModule),
    canActivate: [AuthGuard],
    data: { title: "User-Bereich" },
  },
  {
    path: "kundenstatusliste",
    loadChildren: () =>
      import("./kundenstatusliste/kundenstatusliste.module").then((m) => m.KundenprozesseListPageModule),
    canActivate: [AuthGuard],
    data: { title: "Kundenstatusliste", limitContainerWidth: false },
  },
  {
    path: "aktsuche",
    loadChildren: () => import("./aktsuche/aktsuche.module").then((m) => m.AktsuchePageModule),
    canActivate: [AuthGuard],
    data: { title: "Aktsuche" },
  },
  {
    path: "mailmanager",
    loadChildren: () => import("./mailmanager/mailmanager.module").then((m) => m.MailmanagerPageModule),
    canActivate: [AuthGuard],
    data: { title: "mailManager" },
    resolve: {
      userData: MailmanagerResolve,
    },
  },
  {
    path: "todos",
    loadChildren: () => import("./termintabelle/termintabelle.module").then((m) => m.TermintabellePageModule),
    canActivate: [AuthGuard],
    data: { title: "TODOs" },
  },
  {
    path: "verrechnung",
    loadChildren: () => import("./verrechnung/verrechnung.module").then((m) => m.TermintabellePageModule),
    canActivate: [AuthGuard],
    data: { title: "Verrechnung" },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
